import { ComponentRef, Directive, Input, OnChanges, OnInit, ViewContainerRef } from '@angular/core';
import { NkChanges } from '@nk/utils-lib';
import { EntityWithUuid, NkCardListItem, NkCardListItemConfig } from '../card-list.utils';

@Directive({
  selector: '[nkCardListItem]',
  standalone: true,
})
export class CardListItemDirective<Entity extends EntityWithUuid> implements OnInit, OnChanges {
  @Input() public nkCardListItemComponent: NkCardListItemConfig<Entity>['component'] | undefined;
  @Input() public entityProp: keyof Entity | undefined;
  @Input() public highlightText: string | undefined;
  @Input() public set entity(entity: Entity | undefined) {
    this._entity = entity;
    this._updateValue(this._entity);
  }
  public get entity(): Entity | undefined {
    return this._entity;
  }
  private _entity: Entity | undefined;
  private _componentRef: ComponentRef<NkCardListItem<Entity>> | undefined;

  constructor(private _container: ViewContainerRef) {}

  private _updateValue(row: Entity | undefined): void {
    if (this._componentRef) {
      if (typeof this.entityProp !== 'undefined') {
        this._componentRef.instance.prop = this.entityProp;
      }
      if (typeof row !== 'undefined') {
        this._componentRef.instance.entity = row;
      }
    }
  }

  public ngOnInit(): void {
    if (this.nkCardListItemComponent) {
      this._componentRef = this._container.createComponent(this.nkCardListItemComponent);
      this._updateValue(this._entity);
    }
  }

  // TODO: fix me
  // @ts-ignore
  public ngOnChanges(changes: NkChanges<CardListItemDirective<Entity>>): void {
    if (changes.highlightText && this._componentRef?.instance) {
      this._componentRef.instance.highlightText = changes.highlightText.currentValue;
    }
  }
}
